/* Lead Time Calculator: the date math (2026-10-21).
   Used by sections/lead-time-calculator.liquid (through assets/lead-time-page.js). Plain ES5, no DOM,
   so scripts/tests/test-lead-time.js runs it in Node as well.

   The flow matches the old calculator (and the product page's Order Ship Date Estimator, which keeps
   its own copy for now): the order is processed on the first business day, the proof goes out the
   next business day, production starts the business day after the proof is approved, and the order
   ships on the last production day. What changed:
   - the WHOLE range is used: "5-7 business days" ships between day 5 and day 7 (the old page used 5);
   - production days follow the country where the product is DECORATED ("Made in China, Decorated in
     the United States" = US holidays; the old page used China's for those 922 products);
   - order processing, proofs and UPS shipping always follow US business days (that's us and UPS);
   - holidays are worked out for any year from their rules; the lunar ones (Chinese New Year, Dragon
     Boat, Mid-Autumn) come from the table below, which runs through 2036 — add years before then. */
(function (root) {
  'use strict';

  /* ── lunar holidays (month-day) ── */
  var CNY = { 2024: '02-10', 2025: '01-29', 2026: '02-17', 2027: '02-06', 2028: '01-26', 2029: '02-13', 2030: '02-03', 2031: '01-23', 2032: '02-11', 2033: '01-31', 2034: '02-19', 2035: '02-08', 2036: '01-28' };
  var DRAGON = { 2024: '06-10', 2025: '05-31', 2026: '06-19', 2027: '06-09', 2028: '05-28', 2029: '06-16', 2030: '06-05', 2031: '06-24', 2032: '06-12', 2033: '06-01', 2034: '06-20', 2035: '06-10', 2036: '05-30' };
  var MIDAUTUMN = { 2024: '09-17', 2025: '10-06', 2026: '09-25', 2027: '09-15', 2028: '10-03', 2029: '09-22', 2030: '09-12', 2031: '10-01', 2032: '09-19', 2033: '09-08', 2034: '09-27', 2035: '09-16', 2036: '10-04' };
  var CNY_DAYS = 7; /* factories close from Chinese New Year's Day for a week */

  var COUNTRY_NAME = { US: 'United States', CN: 'China', MX: 'Mexico' };

  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function key(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function day(y, m, d) { return new Date(y, m - 1, d, 12, 0, 0, 0); }
  function clone(d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 12, 0, 0, 0); }
  function parseDate(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(s || ''));
    if (!m) return null;
    var d = day(+m[1], +m[2], +m[3]);
    return (d.getMonth() + 1 === +m[2] && d.getDate() === +m[3]) ? d : null;
  }
  function addDays(d, n) { var c = clone(d); c.setDate(c.getDate() + n); return c; }
  /* the n-th weekday (0 Sun … 6 Sat) of a month; n = -1 = the last one */
  function nthWeekday(y, m, wd, n) {
    if (n > 0) {
      var f = day(y, m, 1);
      return day(y, m, 1 + ((wd - f.getDay() + 7) % 7) + (n - 1) * 7);
    }
    var l = day(y, m + 1, 0);
    return day(y, m, l.getDate() - ((l.getDay() - wd + 7) % 7));
  }
  /* a Saturday holiday is observed the Friday before, a Sunday one the Monday after */
  function observed(d) {
    if (d.getDay() === 6) return addDays(d, -1);
    if (d.getDay() === 0) return addDays(d, 1);
    return d;
  }
  function easter(y) { /* anonymous Gregorian algorithm */
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1;
    return day(y, mo, da);
  }

  function usYear(y) {
    var out = [];
    function add(d, n) { out.push([d, n]); }
    add(observed(day(y, 1, 1)), "New Year's Day");
    add(nthWeekday(y, 1, 1, 3), 'Martin Luther King Jr. Day');
    add(nthWeekday(y, 2, 1, 3), "Presidents' Day");
    add(nthWeekday(y, 5, 1, -1), 'Memorial Day');
    add(observed(day(y, 7, 4)), 'Independence Day');
    add(nthWeekday(y, 9, 1, 1), 'Labor Day');
    var tg = nthWeekday(y, 11, 4, 4);
    add(tg, 'Thanksgiving');
    add(addDays(tg, 1), 'Day after Thanksgiving');
    var xm = day(y, 12, 25);
    add(observed(xm), 'Christmas Day');
    if (xm.getDay() >= 1 && xm.getDay() <= 4) add(day(y, 12, 26), 'Day after Christmas');
    return out;
  }
  function cnYear(y) {
    var out = [];
    function add(d, n) { out.push([d, n]); }
    function md(t) { var p = t.split('-'); return day(y, +p[0], +p[1]); }
    add(day(y, 1, 1), "New Year's Day");
    if (CNY[y]) { var c = md(CNY[y]); for (var i = 0; i < CNY_DAYS; i++) add(addDays(c, i), 'Chinese New Year'); }
    add(day(y, 4, (y % 4 === 0 || y % 4 === 1) ? 4 : 5), 'Qingming Festival');
    for (var j = 1; j <= 3; j++) add(day(y, 5, j), 'Labor Day');
    if (DRAGON[y]) add(md(DRAGON[y]), 'Dragon Boat Festival');
    if (MIDAUTUMN[y]) add(md(MIDAUTUMN[y]), 'Mid-Autumn Festival');
    for (var k = 1; k <= 7; k++) add(day(y, 10, k), 'National Day');
    return out;
  }
  function mxYear(y) {
    var out = [];
    function add(d, n) { out.push([d, n]); }
    add(day(y, 1, 1), "New Year's Day");
    add(nthWeekday(y, 2, 1, 1), 'Constitution Day');
    add(nthWeekday(y, 3, 1, 3), "Benito Juárez's Birthday");
    var ea = easter(y);
    add(addDays(ea, -3), 'Holy Thursday');
    add(addDays(ea, -2), 'Good Friday');
    add(day(y, 5, 1), 'Labor Day');
    add(day(y, 9, 16), 'Independence Day');
    add(nthWeekday(y, 11, 1, 3), 'Revolution Day');
    add(day(y, 12, 25), 'Christmas Day');
    return out;
  }
  var BUILD = { US: usYear, CN: cnYear, MX: mxYear };
  var cache = {};
  /* map of 'YYYY-MM-DD' → holiday name for that country, covering the given year (an observed
     New Year's Day can land on Dec 31 of the year before, so the next year is folded in too) */
  function holidays(cal, y) {
    var c = BUILD[cal] ? cal : 'US';
    var ck = c + y;
    if (cache[ck]) return cache[ck];
    var map = {};
    [y, y + 1].forEach(function (yy) {
      BUILD[c](yy).forEach(function (h) { if (!map[key(h[0])]) map[key(h[0])] = h[1]; });
    });
    cache[ck] = map;
    return map;
  }
  function holidayName(d, cal) { return holidays(cal, d.getFullYear())[key(d)] || null; }
  function isBizDay(d, cal) {
    var w = d.getDay();
    return w !== 0 && w !== 6 && !holidayName(d, cal);
  }
  function nextBizDay(d, cal) { var c = clone(d); while (!isBizDay(c, cal)) c = addDays(c, 1); return c; }
  function addBizDays(d, n, cal) {
    var c = clone(d), k = 0;
    while (k < n) { c = addDays(c, 1); if (isBizDay(c, cal)) k++; }
    return c;
  }
  /* business days from a to b: 0 when the same day, negative when b is before a */
  function bizDiff(a, b, cal) {
    var s = clone(a), e = clone(b), n = 0;
    if (key(s) === key(e)) return 0;
    var fwd = e > s;
    var c = s;
    while (key(c) !== key(e)) { c = addDays(c, fwd ? 1 : -1); if (isBizDay(c, cal)) n++; }
    if (!fwd) return -n;
    return n;
  }

  /* "5-7 business days after proof approval + transit time" → {lo:5, hi:7}; null when there's no number */
  function parseRange(txt) {
    if (!txt) return null;
    var s = String(txt);
    var cut = s.toLowerCase().indexOf('business');
    var head = cut > 0 ? s.slice(0, cut) : s;
    var nums = (head.match(/\d+/g) || []).map(Number).filter(function (n) { return n > 0 && n <= 60; });
    if (!nums.length) return null;
    return { lo: Math.min.apply(null, nums), hi: Math.max.apply(null, nums) };
  }

  /* where production happens: the country it's DECORATED in, else where it's made */
  function prodCountry(origin, shipsFrom) {
    var o = String(origin || '').toLowerCase();
    var m = /decorated in (?:the )?([a-z .]+)/.exec(o);
    var place = m ? m[1] : '';
    if (!place) { var m2 = /(?:made|assembled|produced)(?: and decorated)? in (?:the )?([a-z .]+)/.exec(o); place = m2 ? m2[1] : ''; }
    if (!place && !o) place = String(shipsFrom || '').toLowerCase();
    if (/china/.test(place)) return 'CN';
    if (/mexico/.test(place)) return 'MX';
    return 'US';
  }
  function shipsDirect(shipsFrom) { return /china|overseas|direct/i.test(String(shipsFrom || '')); }

  /* Where a product ships from, for the UPS transit lookup: the rate worker works the ZIP out itself from the product id
     and the public ships-from text (ups-rate-proxy originForProduct), so no page carries the supplier's dock ZIP
     (security review 2026-10-27). originBody = the fields for the /rate request; originKey = a cache key for them. */
  function originBody(productId, shipsFrom) {
    return { productId: String(productId || '').replace(/\D/g, ''), shipsFrom: String(shipsFrom || '') };
  }
  function originKey(productId, shipsFrom) {
    var b = originBody(productId, shipsFrom);
    return b.productId ? 'p' + b.productId : 's' + b.shipsFrom.toLowerCase();
  }

  /* Shipping methods: UPS Ground days come from UPS for the ZIP (else the standard allowance). */
  var GROUND_ALLOWANCE = 5;
  var METHODS = {
    ground: { code: '03', name: 'UPS Ground', days: null },
    '3day': { code: '12', name: 'UPS 3 Day Select', days: 3 },
    '2day': { code: '02', name: 'UPS 2nd Day Air', days: 2 },
    '1day': { code: '01', name: 'UPS Next Day Air', days: 1 }
  };

  /* The plan for one product.
     o = { order: Date, lo, hi, cal: production country, approveLate: business days the proof
           approval slips, changesLo/changesHi: business days proof changes add, transit: business days } */
  function plan(o) {
    var cal = BUILD[o.cal] ? o.cal : 'US';
    var order = clone(o.order);
    var received = nextBizDay(order, 'US');
    var proof = addBizDays(received, 1, 'US');
    var approve = addBizDays(proof, o.approveLate || 0, 'US');
    var apprLo = addBizDays(approve, o.changesLo || 0, 'US');
    var apprHi = addBizDays(approve, o.changesHi || 0, 'US');
    var startLo = nextBizDay(addDays(apprLo, 1), cal);
    var startHi = nextBizDay(addDays(apprHi, 1), cal);
    var shipLo = addBizDays(startLo, Math.max(0, o.lo - 1), cal);
    var shipHi = addBizDays(startHi, Math.max(0, o.hi - 1), cal);
    var t = Math.max(0, o.transit || 0);
    var handLo = addBizDays(shipLo, t, 'US');
    var handHi = addBizDays(shipHi, t, 'US');
    /* closed days (not weekends) between the order and the latest in-hand date */
    var closed = [], seen = {};
    for (var c = clone(order); c <= handHi; c = addDays(c, 1)) {
      var w = c.getDay();
      if (w === 0 || w === 6) continue;
      var inProd = c >= startLo && c <= shipHi;
      var nm = inProd ? holidayName(c, cal) : null;
      var who = inProd && nm ? cal : null;
      if (!nm) { nm = holidayName(c, 'US'); who = nm ? 'US' : null; }
      if (nm && !seen[key(c)]) { seen[key(c)] = 1; closed.push({ date: clone(c), name: nm, cal: who, prod: !!(inProd && who === cal) }); }
    }
    return {
      order: order, received: received, proof: proof, approve: approve, apprLo: apprLo, apprHi: apprHi,
      startLo: startLo, startHi: startHi, shipLo: shipLo, shipHi: shipHi, handLo: handLo, handHi: handHi,
      transit: t, cal: cal, closed: closed
    };
  }

  /* the latest order date whose slow-end in-hand date is on or before the event */
  function orderBy(event, o) {
    var d = clone(event);
    for (var i = 0; i < 200; i++) {
      if (isBizDay(d, 'US')) {
        var p = plan({ order: d, lo: o.hi, hi: o.hi, cal: o.cal, approveLate: o.approveLate, changesLo: o.changesHi, changesHi: o.changesHi, transit: o.transit });
        if (p.handHi <= event) return d;
      }
      d = addDays(d, -1);
    }
    return null;
  }

  /* how a plan lines up with an in-hands date: ok | maybe | late */
  function verdict(p, event) {
    if (!event) return null;
    if (p.handHi <= event) return { kind: 'ok', spare: bizDiff(p.handHi, event, 'US') };
    if (p.handLo <= event) return { kind: 'maybe', spare: 0, over: bizDiff(event, p.handHi, 'US') };
    return { kind: 'late', over: bizDiff(event, p.handLo, 'US'), overHi: bizDiff(event, p.handHi, 'US') };
  }

  var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function fmt(d, withYear) {
    if (!d) return '';
    return DOW[d.getDay()] + ', ' + MON[d.getMonth()] + ' ' + d.getDate() + (withYear ? ', ' + d.getFullYear() : '');
  }
  function fmtRange(a, b, withYear) {
    if (key(a) === key(b)) return fmt(a, withYear);
    return fmt(a, withYear) + ' – ' + fmt(b, withYear);
  }
  function plural(n, w) { return n + ' ' + w + (n === 1 ? '' : 's'); }

  /* Weekends in transit (2026-10-29, Brett: "Ships Nov 13" with "1 business day" next to "In hand Nov 16" read as a
     mistake; "include verbiage about the weekend so it doesnt cause confusion"). UPS counts business days and doesn't
     deliver on Saturday or Sunday, so a Friday shipment with 1 day in transit arrives Monday. */
  function weekendIn(a, b) { for (var c = addDays(a, 1); c < b; c = addDays(c, 1)) { var w = c.getDay(); if (w === 0 || w === 6) return true; } return false; }
  function overWeekend(p) { return !!(p && p.transit && (weekendIn(p.shipLo, p.handLo) || weekendIn(p.shipHi, p.handHi))); }
  /* a few words after "UPS Ground to 60601, 1 business day" */
  function weekendTag(p) {
    if (!overWeekend(p)) return '';
    return key(p.shipLo) === key(p.shipHi) ? ' · ships ' + DOW[p.shipLo.getDay()] + ', no weekend delivery' : ' · no weekend delivery';
  }
  /* the sentence under the dates */
  function weekendNote(p, svc) {
    if (!overWeekend(p)) return '';
    return key(p.shipLo) === key(p.shipHi) && key(p.handLo) === key(p.handHi)
      ? 'Ships ' + fmt(p.shipLo) + '. ' + (svc || 'UPS') + ' takes ' + plural(p.transit, 'business day') + ' and UPS doesn’t deliver on weekends, so it arrives ' + fmt(p.handLo) + '.'
      : 'UPS doesn’t deliver on weekends, so Saturday and Sunday aren’t counted in the ' + plural(p.transit, 'business day') + ' in transit.';
  }

  var api = {
    CNY: CNY, DRAGON: DRAGON, MIDAUTUMN: MIDAUTUMN, COUNTRY_NAME: COUNTRY_NAME, METHODS: METHODS,
    GROUND_ALLOWANCE: GROUND_ALLOWANCE, DOW: DOW, MON: MON,
    key: key, day: day, clone: clone, parseDate: parseDate, addDays: addDays, nthWeekday: nthWeekday,
    easter: easter, holidays: holidays, holidayName: holidayName, isBizDay: isBizDay, nextBizDay: nextBizDay,
    addBizDays: addBizDays, bizDiff: bizDiff, parseRange: parseRange, prodCountry: prodCountry,
    shipsDirect: shipsDirect, originBody: originBody, originKey: originKey, plan: plan, orderBy: orderBy,
    verdict: verdict, fmt: fmt, fmtRange: fmtRange, plural: plural, overWeekend: overWeekend, weekendTag: weekendTag, weekendNote: weekendNote
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.IDPSLeadTime = api;
})(this);
